
export function loadEditData () {
    this.editData = this.env.getPageInfo('admin-buttons-display-edit');
}

export function saveEditData () {
    this.env.setPageInfo('admin-buttons-display-edit', this.editData);
}
